import { Icon } from "armstrong-react";
import classnames from "classnames";
import React from "react";

import "./circleExpandButton.scss";

interface Props {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  controlsId: string;
  active: boolean;
  disabled?: boolean;
  label?: string;
}

/**
 * Animated circle button for in-page interaction.
 * See Storybook for usage info.
 */
export const CircleExpandButton: React.FC<Props> = ({ disabled, onClick, label, controlsId, active }: Props) => {
  const circleClass = classnames("circle-expand-btn__circle", {
    "circle-expand-btn__circle--active": active,
  });
  const iconClass = classnames("circle-expand-btn__icon", {
    "circle-expand-btn__icon--active": active,
  });
  const labelClass = classnames("circle-expand-btn__label", {
    "circle-expand-btn__label--active": active,
  });

  return (
    <button
      type="button"
      className="circle-expand-btn"
      disabled={disabled}
      onClick={onClick}
      onMouseLeave={e => e.currentTarget.blur()}
      onTouchEnd={e => e.currentTarget.blur()}
      aria-label={label}
      aria-expanded={active}
      aria-controls={controlsId}
      id={`btn-${controlsId.toString()}`}
    >
      <div className="circle-expand-btn__wrap">
        <svg className="circle-expand-btn__svg" x="0px" y="0px" viewBox="0 0 125 125">
          <circle className={`${circleClass} circle-expand-btn__circle--thin`} cx="62.5" cy="62.5" r="50" />
          <circle className={`${circleClass} circle-expand-btn__circle--fat`} cx="62.5" cy="62.5" r="50" />
        </svg>
        <Icon className={iconClass} icon={Icon.Icomoon.arrowDown3} />
      </div>

      {label && <span className={labelClass}>{label}</span>}
    </button>
  );
};
